import React from 'react';
import { createRoot } from 'react-dom/client';
import CompanionWidget from './components/CompanionWidget';
let widgetRoot = null;
let widgetContainer = null;
let isInitialized = false;
const initCompanionSystem = () => {
    // Prevent duplicate initialization
    if (isInitialized)
        return;
    isInitialized = true;
    // Companion system initialized
    // Listen for companion activation
    window.addEventListener('companion-activated', handleCompanionActivated);
    // Check for existing companion on load
    checkExistingCompanion();
};
const handleCompanionActivated = (event) => {
    // Companion activated
    const { companionId, companion, state } = event.detail;
    if (!companion) {
        console.error('No companion data provided');
        return;
    }
    // Track companion assignment for GA4
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'companion_assigned',
        character_id: companionId,
    });
    mountCompanionWidget(companion, state);
};
const checkExistingCompanion = () => {
    const companionSystem = window.companionSystem;
    const savedState = localStorage.getItem('companion-state');
    // Scenario 1: Settings disabled - clear storage
    if (!companionSystem || !companionSystem.enabled) {
        if (savedState) {
            // Clearing companion - system disabled
            localStorage.removeItem('companion-state');
        }
        return;
    }
    // Scenario 2: All companion products out of stock - clear storage
    const companionProducts = companionSystem.companionProducts || [];
    if (companionProducts.length > 0) {
        const allProductsOutOfStock = companionProducts.every((product) => product.variants.every((variant) => !variant.available));
        if (allProductsOutOfStock) {
            if (savedState) {
                // Clearing companion - all products out of stock
                localStorage.removeItem('companion-state');
            }
            return;
        }
    }
    if (!savedState)
        return;
    try {
        const state = JSON.parse(savedState);
        if (state.companion_id) {
            const companion = companionSystem.companions[state.companion_id];
            // Scenario 3: Companion ID no longer exists in metafields - clear storage
            if (!companion) {
                // Clearing companion - ID no longer exists
                localStorage.removeItem('companion-state');
                return;
            }
            // Loading existing companion
            mountCompanionWidget(companion, state);
        }
    }
    catch (error) {
        console.error('Failed to load existing companion, clearing storage:', error);
        localStorage.removeItem('companion-state');
    }
};
const mountCompanionWidget = (companion, state) => {
    // Clean up existing widget if any
    unmountCompanionWidget();
    // Create container for widget
    widgetContainer = document.createElement('div');
    widgetContainer.className = 'companion-widget-container';
    widgetContainer.style.position = 'fixed';
    widgetContainer.style.pointerEvents = 'none'; // Allow clicks to pass through container
    widgetContainer.style.top = '0';
    widgetContainer.style.left = '0';
    widgetContainer.style.width = '100%';
    widgetContainer.style.height = '100%';
    widgetContainer.style.zIndex = '900';
    // Allow clicks on actual widget elements
    const style = document.createElement('style');
    style.textContent = `
    .companion-widget {
      pointer-events: auto;
    }
  `;
    widgetContainer.appendChild(style);
    document.body.appendChild(widgetContainer);
    // Mount React component
    widgetRoot = createRoot(widgetContainer);
    widgetRoot.render(React.createElement(CompanionWidget, { companion: companion, state: state }));
    // Companion widget mounted
};
const unmountCompanionWidget = () => {
    if (widgetRoot) {
        widgetRoot.unmount();
        widgetRoot = null;
    }
    if (widgetContainer) {
        document.body.removeChild(widgetContainer);
        widgetContainer = null;
    }
};
// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    // Small delay to ensure companion system config is loaded
    setTimeout(initCompanionSystem, 100);
});
// Also initialize immediately if DOM is already loaded
if (document.readyState === 'loading') {
    // DOM is still loading, event listener above will handle it
}
else {
    // DOM is already loaded
    setTimeout(initCompanionSystem, 100);
}
export default initCompanionSystem;
